import styled from 'styled-components'

export default (styled.span || styled.Text)`
  display: block;
  font-style: italic;
`
